import WaveSurfer from 'wavesurfer.js';
import RegionPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions.min.js';
import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';


export default class Surfer {
    constructor(core) {
        this.core = core
        this.instance = null;
        this.audioBuffer = null;
        this.start = null;
        this.isPlaying = false;
        this.isFinish = false;
        this.setPause = null;
    }

    create() {
        this.instance = WaveSurfer.create({
            cursorWidth: 1,
            container: '#waveform',
            backend: 'WebAudio',
            height: 90,
            backgroundColor: '#2b478b',
            progressColor: '#699dee',
            responsive: true,
            waveColor: '#EFEFEF',
            cursorColor: 'transparent',
            plugins: [
                RegionPlugin.create(),
                CursorPlugin.create({
                    opacity: 1,
                    color: 'aqua'
                })
            ]
        });
    }

    async register(recordedChunks) {
        this.audioBuffer = await this.core.converter.toAudioBuffer(
            this.core.recorder.audioCtx,
            recordedChunks
        )
        const wav = this.core.converter.toWav(this.audioBuffer)
        this.instance.loadBlob(wav)
        this.instance.addRegion({
            end: this.audioBuffer.duration,
            color: 'green',
        })
        const regionToAudioBuffer = function(region) {
            this.start = region.start;
            const segmentDuration = region.end - region.start
            const originalBuffer = this.instance.backend.buffer;
            const emptySegment = this.instance.backend.ac.createBuffer(
                originalBuffer.numberOfChannels,
                segmentDuration * originalBuffer.sampleRate,
                originalBuffer.sampleRate
            );
            for (let i = 0; i < originalBuffer.numberOfChannels; i++) {
                const chanData = originalBuffer.getChannelData(i);
                const emptySegmentData = emptySegment.getChannelData(i);
                let mid_data = chanData.subarray(region.start * originalBuffer.sampleRate, region.end * originalBuffer.sampleRate);
                if (emptySegment.length !== mid_data.length) {
                    mid_data = mid_data.slice(0, emptySegment.length)
                }
                emptySegmentData.set(mid_data);
            }
            this.audioBuffer = emptySegment
        }
        this.instance.on('region-update-end', regionToAudioBuffer.bind(this), false);
        const onFinish = function() {
            console.log('finish')
            this.isPlaying = false;
            this.isFinish = true;
            //this.start = null;
            this.setPause(false)
        }
        this.instance.on('finish', onFinish.bind(this), false)
        const onPause = function(test) {
            console.log('pause')
            if (!this.isFinish) {
                this.start = this.instance.getCurrentTime()
            }
        }
        this.instance.on('pause', onPause.bind(this), false)
        const onInteraction = function(test) {
            console.log('interaction')
            if (!this.isFinish) {
                this.start = this.instance.getCurrentTime()
            }
            // this.isFinish = false;
        }
        this.instance.on('interaction', onInteraction.bind(this), false)
    }

    playPause() {
        if (!this.isPlaying) {
            if (this.start) {
                this.instance.play(this.start);
            } else {
                this.instance.play()
            }
        } else {
            this.instance.pause();
        }
        this.isPlaying = !(this.isPlaying);
        //this.instance.playPause();
    }

    save() {
        const wav = this.core.converter.toWav(this.audioBuffer)
        const url = URL.createObjectURL(wav);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `record_${(new Date().toJSON().slice(0,19).replace(':', '-'))}.wav`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}
